module.exports = __webpack_public_path__ + "static/og-image-9dc75fbbb33761cefdf12728b6d645ed.png";